import store from '../../../../global-state/redux';

export const isActive = () => store.getState().appState.settings?.communicableOnly?.isActive;
export const modalName = () => store.getState().appState.settings?.communicableOnly?.modalName;
